<div
  class="text-center relative color-light border-radius-5 overflow-hidden m-a pointer"
  style="max-width: fit-content"
  [routerLink]="['/', paths.PLATFORM, paths.platform.MORTGAGE_DETAIL, mortgageId]">
  <!-- Header -->
  <cp-widget-header text="Mortgage status" icon="mortgage" [isAbsolutePosition]="true" />

  <!-- Video -->
  <div class="relative" visibility (visibilityChange)="playVideo($event)">
    <video
      class="border-radius-5"
      #bestDealVid
      (ended)="videoEnded = true"
      style="width: 100%"
      playsinline
      [muted]="muted"
      [poster]="'dashboard-widget-poster-calendar.jpg' | brandingAssetPath">
      @if (!isCompanyBranded) {
        <source src="/assets/videos/calendar.mp4" type="video/mp4" />
      }
      Your browser does not support the video tag.
    </video>
  </div>

  <!-- Contents -->
  <ng-container *ngTemplateOutlet="videoContent" />
</div>

<ng-template #videoContent>
  <div class="w-100 h-100 z-index-1 absolute video-content pt-5 pb-3">
    <div class="text-28 bold-800 px-3 text-center pt-3">Callback Scheduled</div>
    <div class="text-14 px-5 pb-3 bottom-3 text-center">
      A callback has been scheduled for you! One of our experienced and friendly mortgage experts
      will be in touch to discuss the deal you've found as soon as possible.
    </div>
  </div>
</ng-template>
